import React from 'react'
import MasterPage from "../../../EstruturaAntiga/masterpages/simpleAuthenticated"
import { useAuth } from 'context/AuthContext'
import ContentBox from 'components/ContentBox';
import { Button } from 'antd';

const TermoDeAceite = ({...props}) => {
    const {AceitarTermoAceite} = useAuth();

    const HandleAceitarTermo = async () =>{
        const sucesso = await AceitarTermoAceite(props.termo.id)
        if(sucesso){
            props.selecionarTermo(null)
        }
    }

    return (
        <MasterPage>
            <h1>{ props.termo ? props.termo.titulo : '' }</h1>
            <ContentBox className="term-text">
                <div className="description-term" dangerouslySetInnerHTML={{ __html: props.termo ? props.termo.descricao : '' }} />
            </ContentBox>

            <div className="term-action">
                <div className="container">
                    <div className="actions">
                        <Button onClick={ () => props.selecionarTermo(null)} color="primary" variant="outlined" style={{marginRight: "8px"}}>Voltar</Button>
                        <Button onClick={ () => HandleAceitarTermo() } type="primary">Declaro ter lido e aceito os termos</Button>
                    </div>
                </div>
            </div>
        </MasterPage>
    );
}
export default TermoDeAceite